module.exports = __webpack_public_path__ + "img/pelleter-1.8a19254d.png";